import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useMemo } from "react";
import Header from "./Header";
import Footer from "./Footer";
import {
  SINGLE_ONLY_CENTER_PATHS,
  getCenterTitle,
  isMarriedUser,
} from "../constants/maritalStatus";
import useUserMaritalStatus from "../hooks/useUserMaritalStatus";

const singleMenuItems = [
  { to: "/center", label: "用户中心", end: true },
  { to: "/center/profile", label: "资料设置" },
  { to: "/center/verify", label: "我的认证" },
  { to: "/center/security", label: "账号安全" },
  { to: "/center/preview", label: "主页预览" },
  { to: "/center/views", label: "谁看了我" },
  { to: "/center/friends", label: "我的好友" },
  { to: "/center/albums", label: "我的相册" },
  { to: "/center/inbox", label: "收件箱" },
  { to: "/center/messages", label: "系统消息" },
  { to: "/center/ebook-downloads", label: "我的下载" },
  { to: "/shop/orders", label: "好物订单" },
  { to: "/secondhand/mine", label: "我的闲置" },
  { to: "/secondhand/new", label: "发布闲置" },
  { to: "/love-map", label: "AI爱情地图" },
  { to: "/love-map/couple", label: "双人爱情地图" },
  { to: "/ai/consultant", label: "AI咨询师" },
  { to: "/ai/match", label: "AI匹配报告" },
  { to: "/center/ai-memory", label: "我的AI记忆" },
];

const marriedMenuItems = [
  { to: "/center", label: "婚姻中心", end: true },
  { to: "/center/profile", label: "资料设置" },
  { to: "/center/verify", label: "我的认证" },
  { to: "/center/security", label: "账号安全" },
  { to: "/center/inbox", label: "收件箱" },
  { to: "/center/messages", label: "系统消息" },
  { to: "/center/ebook-downloads", label: "我的下载" },
  { to: "/shop/orders", label: "好物订单" },
  { to: "/secondhand/mine", label: "我的闲置" },
  { to: "/secondhand/new", label: "发布闲置" },
  { to: "/love-map", label: "AI爱情地图" },
  { to: "/love-map/couple", label: "双人爱情地图" },
  { to: "/ai/marriage", label: "AI婚姻顾问" },
  { to: "/center/ai-memory", label: "我的AI记忆" },
  { to: "/questionnaire", label: "关系测评" },
];

export default function CenterLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUserId = localStorage.getItem("user_id");
  const { maritalStatus, isMarried } = useUserMaritalStatus();

  useEffect(() => {
    if (!currentUserId) {
      navigate("/login");
    }
  }, [currentUserId, navigate]);

  useEffect(() => {
    if (!isMarried) {
      return;
    }

    const onSingleOnlyPage = SINGLE_ONLY_CENTER_PATHS.some((path) =>
      location.pathname.startsWith(path)
    );

    if (onSingleOnlyPage) {
      navigate("/center", { replace: true });
    }
  }, [isMarried, location.pathname, navigate]);

  const menuItems = useMemo(
    () => (isMarried ? marriedMenuItems : singleMenuItems),
    [isMarried]
  );

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("user_id");
    localStorage.removeItem("marital_status");
    localStorage.removeItem("name");
    localStorage.removeItem("avatar");
    localStorage.removeItem("love_score");
    navigate("/");
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex flex-col">
      <Header />

      <div className="flex-1 px-4 py-8">
        <div className="max-w-6xl mx-auto grid grid-cols-12 gap-6">
          <aside className="col-span-12 md:col-span-3 bg-white rounded-2xl shadow p-4">
            <h2 className="text-xl font-bold mb-1 text-pink-600">
              {getCenterTitle(maritalStatus)}
            </h2>
            <p className="text-xs text-gray-400 mb-4">
              {isMarriedUser(maritalStatus)
                ? "婚姻修复 · 关系咨询"
                : "交友匹配 · 个人资料"}
            </p>

            <div className="flex flex-col gap-2">
              {menuItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `px-4 py-3 rounded-xl text-sm transition ${
                      isActive
                        ? "bg-pink-500 text-white"
                        : "text-gray-700 hover:bg-pink-50"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}

              <button
                onClick={handleLogout}
                className="mt-4 px-4 py-3 rounded-xl text-sm text-left text-red-500 hover:bg-red-50 transition"
              >
                退出登录
              </button>
            </div>
          </aside>

          <main className="col-span-12 md:col-span-9 bg-white rounded-2xl shadow p-6">
            <Outlet context={{ maritalStatus, isMarried }} />
          </main>
        </div>
      </div>

      <Footer />
    </div>
  );
}
